import { SITE_URL } from "../helpers/Setting";
export const Fetch = async ({ body, auth, api, type }) => {
  return await fetch(SITE_URL + api, {
    method: type,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: auth
    },
    body: body
  }).then(res => {
    if (res.status >= 200 && res.status < 300) {
      return res.json();
    } else {
      throw res;
    }
  });
};
export default Fetch;
